<div class="landing">
  @if (loading()) {
    <!-- Khung chờ: cùng bố cục với trang để không bị nhảy khi dữ liệu về -->
    <div aria-busy="true" aria-label="Đang tải trang">
      <div
        *ngIf="embeddedKind === null"
        class="border-b border-slate-200 bg-slate-50"
      >
        <div class="mx-auto max-w-7xl space-y-3 px-4 py-8">
          <span class="sk block h-4 w-40"></span>
          <span class="sk block h-8 w-2/3 max-w-md"></span>
          <span class="sk block h-4 w-full max-w-lg"></span>
        </div>
      </div>
      <div
        class="mx-auto grid max-w-7xl grid-cols-1 gap-3 px-4 py-8 sm:grid-cols-2 md:gap-4 lg:grid-cols-4"
      >
        @for (n of skeletonItems; track n) {
          <span class="sk block h-56"></span>
        }
      </div>
    </div>
  } @else {
    @let c = content();
    @let t = theme();

    @if (embeddedKind === null) {
      <!-- Breadcrumb -->
      <nav class="border-b border-slate-200 bg-white" aria-label="Breadcrumb">
        <ol
          class="mx-auto flex max-w-7xl flex-wrap items-center gap-1.5 px-4 py-3 text-sm text-slate-500"
        >
          <li>
            <a routerLink="/" class="hover:text-emerald-700">Trang chủ</a>
          </li>
          <li aria-hidden="true">/</li>
          <li class="font-medium text-slate-900" aria-current="page">
            {{ kindLabel() }}
          </li>
        </ol>
      </nav>

      <!-- Thanh tiêu đề gọn -->
      <header class="border-b border-slate-200 bg-slate-50">
        <div class="mx-auto max-w-7xl px-4 py-5">
          <h1 class="m-0 break-words text-2xl font-bold text-slate-900">
            {{ c.hero.title }}
            <span class="text-emerald-700">{{ c.hero.highlightedTitle }}</span>
          </h1>
          <p class="mt-1 line-clamp-2 max-w-3xl text-sm text-slate-600">
            {{ c.hero.description }}
          </p>
        </div>
      </header>
    }

    <div>
      <!-- Danh mục + sản phẩm -->
      <section
        id="catalog"
        class="bg-white py-4"
        aria-labelledby="landing-catalog"
      >
        <div class="mx-auto max-w-7xl px-4">
          <div class="mb-6">
            <h2
              id="landing-catalog"
              class="inline-block border-b-2 border-emerald-600 pb-1 text-xl font-bold text-slate-900"
            >
              {{ c.catalog.heading }}
            </h2>
            <p class="mt-3 max-w-2xl text-sm leading-6 text-slate-600">
              {{ c.catalog.description }}
            </p>
          </div>

          <!-- Mobile: nút mở bộ lọc -->
          <button
            type="button"
            class="mb-4 flex w-full items-center justify-between rounded-md border border-slate-200 bg-white px-4 py-2.5 text-sm font-semibold text-slate-700 lg:hidden"
            [attr.aria-expanded]="filtersOpen()"
            aria-controls="catalog-filters"
            (click)="toggleFilters()"
          >
            <span class="inline-flex items-center gap-2">
              <mat-icon class="!h-5 !w-5" svgIcon="hero:grid_view"></mat-icon>
              Bộ lọc
            </span>
            <mat-icon
              class="!h-5 !w-5"
              [svgIcon]="filtersOpen() ? 'hero:close' : 'hero:expand_more'"
            ></mat-icon>
          </button>

          <div
            class="grid gap-6 lg:grid-cols-[15rem_minmax(0,1fr)] xl:grid-cols-[16rem_minmax(0,1fr)]"
          >
            <!-- Bộ lọc bên trái -->
            <aside
              id="catalog-filters"
              class="min-w-0 space-y-4 lg:block lg:self-start"
              [class.hidden]="!filtersOpen()"
              aria-label="Bộ lọc sản phẩm"
            >
              <div class="rounded-lg border border-slate-200 bg-white">
                <h3
                  class="border-b border-slate-200 px-4 py-2.5 text-sm font-bold uppercase tracking-wide text-slate-900"
                >
                  Danh mục
                </h3>
                <ul class="p-2">
                  <li>
                    <button
                      type="button"
                      class="flex w-full items-center gap-2 rounded-md px-3 py-2 text-left text-sm hover:bg-slate-50"
                      [ngClass]="
                        selectedCategoryId() === null
                          ? 'bg-emerald-50 font-semibold text-emerald-700'
                          : 'text-slate-700'
                      "
                      [attr.aria-pressed]="selectedCategoryId() === null"
                      (click)="selectCategory(null)"
                    >
                      <span class="min-w-0 flex-1 truncate">{{
                        c.catalog.allCategoriesLabel
                      }}</span>
                    </button>
                  </li>

                  @for (root of tree(); track root.id) {
                    <li>
                      <button
                        type="button"
                        class="flex w-full items-center gap-2 rounded-md px-3 py-2 text-left text-sm hover:bg-slate-50"
                        [ngClass]="
                          activeRootId() === root.id
                            ? 'bg-emerald-50 font-semibold text-emerald-700'
                            : 'text-slate-700'
                        "
                        [attr.aria-pressed]="selectedCategoryId() === root.id"
                        (click)="selectCategory(root.id)"
                      >
                        <span class="min-w-0 flex-1 truncate">{{
                          root.name
                        }}</span>
                        <span class="text-xs text-slate-500"
                          >({{ categoryCount(root) }})</span
                        >
                      </button>

                      @if (
                        activeRootId() === root.id && root.children?.length
                      ) {
                        <ul class="ml-3 border-l border-slate-200 pl-2">
                          @for (child of root.children; track child.id) {
                            <li>
                              <button
                                type="button"
                                class="flex w-full items-center gap-2 rounded-md px-3 py-1.5 text-left text-sm hover:bg-slate-50"
                                [ngClass]="
                                  selectedCategoryId() === child.id
                                    ? 'font-semibold text-emerald-700'
                                    : 'text-slate-600'
                                "
                                [attr.aria-pressed]="
                                  selectedCategoryId() === child.id
                                "
                                (click)="selectCategory(child.id)"
                              >
                                <span class="min-w-0 flex-1 truncate">{{
                                  child.name
                                }}</span>
                                @if (
                                  child.productCount !== undefined &&
                                  child.productCount !== null
                                ) {
                                  <span class="text-xs text-slate-500"
                                    >({{ child.productCount }})</span
                                  >
                                }
                              </button>
                            </li>
                          }
                        </ul>
                      }
                    </li>
                  }
                </ul>
              </div>

              @if (brandOptions().length) {
                <div class="rounded-lg border border-slate-200 bg-white">
                  <h3
                    class="border-b border-slate-200 px-4 py-2.5 text-sm font-bold uppercase tracking-wide text-slate-900"
                  >
                    Thương hiệu
                  </h3>
                  <ul class="p-2">
                    <li>
                      <button
                        type="button"
                        class="flex w-full items-center rounded-md px-3 py-2 text-left text-sm hover:bg-slate-50"
                        [ngClass]="
                          brandId() === ''
                            ? 'bg-emerald-50 font-semibold text-emerald-700'
                            : 'text-slate-700'
                        "
                        [attr.aria-pressed]="brandId() === ''"
                        (click)="onBrand('')"
                      >
                        {{ c.catalog.allBrandsLabel }}
                      </button>
                    </li>
                    @for (brand of brandOptions(); track brand.id) {
                      <li>
                        <button
                          type="button"
                          class="flex w-full items-center rounded-md px-3 py-2 text-left text-sm hover:bg-slate-50"
                          [ngClass]="
                            brandId() === brand.id
                              ? 'bg-emerald-50 font-semibold text-emerald-700'
                              : 'text-slate-700'
                          "
                          [attr.aria-pressed]="brandId() === brand.id"
                          (click)="
                            onBrand(brandId() === brand.id ? '' : brand.id)
                          "
                        >
                          <span class="min-w-0 truncate">{{ brand.name }}</span>
                        </button>
                      </li>
                    }
                  </ul>
                </div>
              }

              <div class="rounded-lg border border-slate-200 bg-white">
                <h3
                  class="border-b border-slate-200 px-4 py-2.5 text-sm font-bold uppercase tracking-wide text-slate-900"
                >
                  Khoảng giá
                </h3>
                <div class="grid grid-cols-2 gap-2 p-3">
                  <input
                    type="number"
                    min="0"
                    inputmode="numeric"
                    class="filter-control"
                    [ngClass]="t.focus"
                    [placeholder]="c.catalog.priceFromLabel"
                    [attr.aria-label]="c.catalog.priceFromLabel"
                    [ngModel]="minPrice()"
                    (ngModelChange)="onMinPrice($event)"
                  />
                  <input
                    type="number"
                    min="0"
                    inputmode="numeric"
                    class="filter-control"
                    [ngClass]="t.focus"
                    [placeholder]="c.catalog.priceToLabel"
                    [attr.aria-label]="c.catalog.priceToLabel"
                    [ngModel]="maxPrice()"
                    (ngModelChange)="onMaxPrice($event)"
                  />
                </div>
              </div>

              @if (hasActiveFilters()) {
                <button
                  type="button"
                  class="inline-flex w-full items-center justify-center gap-1.5 rounded-md border border-slate-300 bg-white px-3 py-2 text-sm font-semibold text-slate-700 hover:border-emerald-600 hover:text-emerald-700"
                  (click)="clearFilters()"
                >
                  <mat-icon class="!h-4 !w-4" svgIcon="hero:close"></mat-icon>
                  {{ c.catalog.clearFiltersLabel }}
                </button>
              }
            </aside>

            <div class="min-w-0">
              <!-- Thanh công cụ: tìm kiếm + sắp xếp + số kết quả -->
              <div class="rounded-lg border border-slate-200 bg-slate-50 p-3">
                <div class="grid gap-3 sm:grid-cols-[minmax(0,1fr)_auto]">
                  <label class="relative block min-w-0">
                    <span class="sr-only">{{
                      c.catalog.searchPlaceholder
                    }}</span>
                    <input
                      type="search"
                      class="filter-control pl-10"
                      [ngClass]="t.focus"
                      [placeholder]="c.catalog.searchPlaceholder"
                      [ngModel]="keyword()"
                      (ngModelChange)="onKeyword($event)"
                    />
                  </label>

                  <label class="flex min-w-0 items-center gap-2">
                    <span class="shrink-0 text-sm text-slate-600">{{
                      c.catalog.sortLabel
                    }}</span>
                    <select
                      class="filter-control sm:w-52"
                      [ngClass]="t.focus"
                      [ngModel]="sortBy()"
                      (ngModelChange)="onSort($event)"
                    >
                      @for (option of sortOptions(); track option.value) {
                        <option [value]="option.value">
                          {{ option.label }}
                        </option>
                      }
                    </select>
                  </label>
                </div>

                <p
                  class="mt-3 flex min-w-0 flex-wrap items-center gap-x-2 gap-y-1 text-sm text-slate-600"
                  aria-live="polite"
                >
                  <strong class="font-bold text-slate-900">{{
                    visibleProducts().length
                  }}</strong>
                  <span>{{ c.catalog.resultSuffixLabel }}</span>
                  @if (selectedCategory(); as current) {
                    <span
                      class="rounded-md bg-emerald-50 px-2 py-0.5 text-xs font-semibold text-emerald-700"
                      >{{ current.name }}</span
                    >
                  }
                </p>
              </div>

              <!-- Lưới sản phẩm -->
              <div class="mt-4" [attr.aria-busy]="productsLoading()">
                @if (productsLoading()) {
                  <div
                    class="grid grid-cols-1 gap-3 sm:grid-cols-2 md:gap-4 lg:grid-cols-4 xl:grid-cols-5"
                  >
                    @for (n of skeletonItems; track n) {
                      <div
                        class="overflow-hidden rounded-lg border border-slate-200 bg-white"
                      >
                        <span class="sk block h-40 rounded-none"></span>
                        <div class="space-y-2 p-3">
                          <span class="sk block h-4 w-4/5"></span>
                          <span class="sk block h-4 w-1/2"></span>
                        </div>
                      </div>
                    }
                  </div>
                } @else if (visibleProducts().length) {
                  <div
                    class="grid grid-cols-1 gap-3 sm:grid-cols-2 md:gap-4 lg:grid-cols-3 xl:grid-cols-4"
                  >
                    @for (
                      product of pagedProducts();
                      track product.kind + product.id
                    ) {
                      <app-product-card [product]="product"></app-product-card>
                    }
                  </div>

                  @if (pagedProducts().length < visibleProducts().length) {
                    <div class="mt-6 text-center">
                      <button
                        type="button"
                        class="rounded-md border border-emerald-600 bg-white px-6 py-2.5 text-sm font-semibold text-emerald-700 hover:bg-emerald-700 hover:text-white"
                        (click)="loadMore()"
                      >
                        Xem thêm ({{
                          visibleProducts().length - pagedProducts().length
                        }})
                      </button>
                    </div>
                  }
                } @else {
                  <div
                    class="flex flex-col items-center rounded-lg border border-dashed border-slate-300 bg-white px-6 py-12 text-center"
                  >
                    <mat-icon
                      class="!h-8 !w-8 text-slate-400"
                      svgIcon="hero:search"
                    ></mat-icon>
                    <h3 class="mt-3 text-lg font-bold text-slate-900">
                      {{ c.catalog.emptyTitle }}
                    </h3>
                    <p class="mt-1 max-w-md text-sm leading-6 text-slate-600">
                      {{ c.catalog.emptyDescription }}
                    </p>
                    @if (hasActiveFilters()) {
                      <button
                        type="button"
                        class="mt-4 inline-flex items-center gap-2 rounded-md bg-emerald-700 px-5 py-2 text-sm font-semibold text-white hover:bg-emerald-800"
                        (click)="clearFilters()"
                      >
                        <mat-icon
                          class="!h-4 !w-4"
                          svgIcon="hero:refresh"
                        ></mat-icon>
                        {{ c.catalog.clearFiltersLabel }}
                      </button>
                    }
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </section>

      @if (embeddedKind === null) {
        <!-- Giới thiệu -->
        <section
          class="border-t border-slate-200 bg-white py-8"
          aria-labelledby="landing-intro"
        >
          <div class="mx-auto max-w-7xl px-4">
            <h2
              id="landing-intro"
              class="inline-block border-b-2 border-emerald-600 pb-1 text-xl font-bold text-slate-900"
            >
              {{ c.intro.heading }}
            </h2>
            <p
              class="mt-3 max-w-4xl whitespace-pre-line text-sm leading-7 text-slate-600"
            >
              {{ c.intro.body }}
            </p>
            @if (c.intro.bullets.length) {
              <ul class="m-0 mt-3 grid list-none gap-1.5 p-0 sm:grid-cols-2">
                @for (bullet of c.intro.bullets; track $index) {
                  <li class="flex items-start gap-2 text-sm text-slate-700">
                    <mat-icon
                      class="!h-5 !w-5 shrink-0 text-emerald-600"
                      svgIcon="hero:check"
                    ></mat-icon>
                    <span class="min-w-0">{{ bullet }}</span>
                  </li>
                }
              </ul>
            }
          </div>
        </section>

        <!-- Chính sách / điểm mạnh -->
        <section
          class="border-y border-slate-200 bg-slate-50 py-6"
          aria-label="Điểm mạnh"
        >
          <ul
            class="m-0 mx-auto grid max-w-7xl list-none gap-4 px-4 sm:grid-cols-2 lg:grid-cols-4"
          >
            @for (item of c.highlights; track $index) {
              <li class="flex items-start gap-3">
                <span
                  class="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-emerald-50 text-emerald-700"
                >
                  <mat-icon [svgIcon]="iconOf(item.icon)"></mat-icon>
                </span>
                <span class="min-w-0">
                  <strong class="block text-sm font-semibold text-slate-900">{{
                    item.title
                  }}</strong>
                  <span class="block text-xs leading-5 text-slate-600">{{
                    item.description
                  }}</span>
                </span>
              </li>
            }
          </ul>
        </section>

        <!-- FAQ -->
        <section class="bg-white py-8" aria-labelledby="landing-faq">
          <div class="mx-auto max-w-4xl px-4">
            <h2
              id="landing-faq"
              class="inline-block border-b-2 border-emerald-600 pb-1 text-xl font-bold text-slate-900"
            >
              {{ c.faq.heading }}
            </h2>
            <div
              class="mt-4 divide-y divide-slate-200 rounded-lg border border-slate-200 bg-white"
            >
              @for (item of c.faq.items; track $index; let i = $index) {
                <details class="group" [open]="i === 0">
                  <summary
                    class="flex cursor-pointer list-none items-center justify-between gap-4 px-4 py-3 text-sm font-semibold text-slate-900"
                  >
                    <span class="min-w-0">{{ item.question }}</span>
                    <span
                      class="shrink-0 text-emerald-600 group-open:hidden"
                      aria-hidden="true"
                      >+</span
                    >
                    <span
                      class="hidden shrink-0 text-emerald-600 group-open:inline"
                      aria-hidden="true"
                      >&minus;</span
                    >
                  </summary>
                  <div class="px-4 pb-4 text-sm leading-7 text-slate-600">
                    {{ item.answer }}
                  </div>
                </details>
              }
            </div>
          </div>
        </section>

        <!-- Liên hệ -->
        <section
          id="lien-he"
          class="border-t border-slate-200 bg-slate-50 py-6"
          aria-labelledby="landing-cta"
        >
          <div
            class="mx-auto flex max-w-7xl flex-col gap-4 px-4 md:flex-row md:items-center md:justify-between"
          >
            <div class="min-w-0">
              <h2 id="landing-cta" class="m-0 text-lg font-bold text-slate-900">
                {{ c.cta.heading }}
                <span class="text-emerald-700">{{
                  c.cta.highlightedHeading
                }}</span>
              </h2>
              <p class="mt-1 text-sm text-slate-600">{{ c.cta.description }}</p>
            </div>
            <div class="flex flex-wrap gap-3">
              <a
                [href]="phoneHref(c.cta.phone)"
                class="inline-flex items-center gap-2 rounded-md bg-emerald-700 px-5 py-2.5 text-sm font-semibold text-white hover:bg-emerald-800"
              >
                <mat-icon class="!h-5 !w-5" svgIcon="hero:phone"></mat-icon>
                {{ c.cta.phone }}
              </a>
              <a
                [href]="'mailto:' + c.cta.email"
                class="inline-flex items-center gap-2 rounded-md border border-slate-300 bg-white px-5 py-2.5 text-sm font-semibold text-slate-700 hover:border-emerald-600 hover:text-emerald-700"
              >
                <mat-icon class="!h-5 !w-5" svgIcon="hero:mail"></mat-icon>
                {{ c.cta.email }}
              </a>
            </div>
          </div>
        </section>
      }
    </div>
  }
</div>
